export default __webpack_public_path__ + "static/media/HIM-Vignette.ce88bcbd.pdf";